import { render, staticRenderFns } from "./UserCharge.vue?vue&type=template&id=595ba0f9&"
import script from "./UserCharge.vue?vue&type=script&lang=js&"
export * from "./UserCharge.vue?vue&type=script&lang=js&"
import style0 from "./UserCharge.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports